"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function Mission() {
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: paragraphRef,
    isVisible: paragraphVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: quoteRef,
    isVisible: quoteVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: dividerRef,
    isVisible: dividerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const headlineLines = [{
    words: ["A", "legacy"],
    indent: "ml-0"
  }, {
    words: ["built", "on"],
    indent: "ml-0 md:ml-24"
  }, {
    words: ["integrity."],
    indent: "ml-0 md:ml-48"
  }];
  const paragraphWords = "Every project begins as a commitment. We build with deliberate, precise craftsmanship — never cutting corners, never compromising on quality. Each structure is a study in durability, structural integrity, and the lasting conversation between vision, material, and time.".split(" ");
  return <section data-section-id="2807" id="missionandvalues" className="relative bg-background text-foreground overflow-hidden py-32 md:py-48">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        {}
        <div ref={eyebrowRef} className={`mb-16 md:mb-24 transition-all duration-700 ease-out ${eyebrowVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <span className="font-default text-xs tracking-[0.25em] uppercase" style={{
          color: "var(--chart-2)"
        }}>Mission</span>
        </div>

        {}
        <div ref={headlineRef} className="mb-24 md:mb-32">
          <h2 className="font-default font-light leading-[0.95] text-foreground text-5xl md:text-7xl lg:text-[6.5rem]">
            {headlineLines.map((line, lineIdx) => <span key={lineIdx} data-index={lineIdx} className={`block ${line.indent}`}>
                {line.words.map((word, wordIdx) => {
              const totalDelay = lineIdx * 300 + wordIdx * 120;
              return <span key={wordIdx} className="inline-block overflow-hidden align-bottom mr-[0.25em]">
                      <span className="inline-block transition-all duration-700 ease-out" style={{
                  transform: headlineVisible ? "translateY(0)" : "translateY(100%)",
                  opacity: headlineVisible ? 1 : 0,
                  transitionDelay: `${totalDelay}ms`
                }}>
                        {word}
                      </span>
                    </span>;
            })}
              </span>)}
          </h2>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8 items-start">
          {}
          <div ref={imageRef} data-index={0} className={`md:col-span-4 md:self-center transition-all duration-1000 ease-out ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="aspect-square overflow-hidden rounded-lg shadow-md">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723461/img/construction_blueprint_hands.webp" alt="Americo Moscariello reviewing construction blueprints on site" loading="lazy" decoding="async" className="w-full h-full object-cover" />
            </div>
          </div>

          {}
          <div ref={paragraphRef} data-index={1} className="md:col-span-4 md:mt-20">
            <p className="font-default text-lg md:text-xl leading-relaxed text-foreground">
              <span className="float-left font-default font-medium text-7xl md:text-8xl leading-[0.8] mr-3 mt-1" style={{
              color: "var(--primary)"
            }}>
                E
              </span>
              {paragraphWords.map((word, wordIdx) => {
              if (wordIdx === 0) {
                return <span key={wordIdx} className="inline-block transition-all duration-700 ease-out mr-[0.25em]" style={{
                  opacity: paragraphVisible ? 1 : 0,
                  transform: paragraphVisible ? "translateY(0)" : "translateY(8px)",
                  transitionDelay: `${wordIdx * 35}ms`
                }}>
                      {word.substring(1)}
                    </span>;
              }
              return <span key={wordIdx} className="inline-block transition-all duration-700 ease-out mr-[0.25em]" style={{
                opacity: paragraphVisible ? 1 : 0,
                transform: paragraphVisible ? "translateY(0)" : "translateY(8px)",
                transitionDelay: `${wordIdx * 35}ms`
              }}>
                    {word}
                  </span>;
            })}
            </p>
          </div>

          {}
          <div ref={quoteRef} data-index={2} className={`md:col-span-3 md:col-start-10 transition-all duration-1000 ease-out ${quoteVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="relative pl-6 border-l-2" style={{
            borderColor: "var(--chart-2)"
          }}>
              <p className="font-default italic font-light text-3xl md:text-4xl leading-tight text-foreground">
                "We build
                <br />
                trust."
              </p>
              <p className="mt-4 font-default text-xs tracking-widest uppercase" style={{
              color: "var(--muted-foreground)"
            }}>
                — Americo Moscariello
              </p>
            </div>
          </div>
        </div>

        {}
        <div ref={dividerRef} className={`mt-32 md:mt-48 flex items-center gap-4 transition-all duration-1000 ease-out ${dividerVisible ? "opacity-100" : "opacity-0"}`}>
          <Separator className="flex-1" style={{
          backgroundColor: "var(--secondary)"
        }} />
          <span className="inline-block size-1.5 rounded-lg" style={{
          backgroundColor: "var(--chart-2)"
        }} aria-hidden="true" />
          <Separator className="flex-1" style={{
          backgroundColor: "var(--secondary)"
        }} />
        </div>
      </div>
    </section>;
}